import { api } from "@/lib/api/client";
import type { AuthUser } from "./types";

export const authApi = {
  me: () => api.get<AuthUser>("/api/auth/me/"),
  login: (email: string, password: string) =>
    api.post<AuthUser>("/api/auth/login/", { email, password }),
  register: (email: string, password: string, name?: string) =>
    api.post<AuthUser>("/api/auth/register/", { email, password, name }),
  logout: () => api.post<void>("/api/auth/logout/"),
};
